const defaultState = {
  pricingAreas: [],
  error: "",
  pricingAreaRequest: false,
};

const areaReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "PRICING_AREA_LIST_REQUEST":
      return {
        ...state,
        pricingAreaRequest: true,
      };
    case "PRICING_AREA_LIST_REQUEST_SUCCESS":
      return {
        ...state,
        pricingAreaRequest: false,
        ...action.payload,
      };
    case "PRICING_AREA_LIST_REQUEST_FAILED":
      return {
        ...state,
        pricingAreaRequest: false,
        erros: action.payload,
      };
    default:
      return state;
  }
};

export default areaReducer;



// WEBPACK FOOTER //
// src/store/reducers/area.js